module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('span', [_vm._v("Displaying " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " items")]), _vm._v(" "), _c('div', {
    staticClass: "is-pulled-right"
  }, [_vm._v("Show\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.showPerPage]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "200"
    }
  }, [_vm._v("200")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "300"
    }
  }, [_vm._v("300")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "400"
    }
  }, [_vm._v("400")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "500"
    }
  }, [_vm._v("500")])])])]), _vm._v(" "), _c('div', [_c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', [_c('a', {
    staticClass: "button",
    class: [_vm.pagination.current_page === 1 ? 'is-disabled' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.nextPrev($event, _vm.pagination.current_page - 1)
      }
    }
  }, [_c('span', [_vm._v("«")])])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', [(page === '...') ? _c('span', {
      staticClass: "button"
    }, [_vm._v(_vm._s(page))]) : _vm._e(), _vm._v(" "), (page !== '...') ? _c('a', {
      staticClass: "button",
      class: [_vm.pagination.current_page === page ? 'is-active is-primary' : ''],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.navigate($event, page)
        }
      }
    }, [_vm._v(_vm._s(page))]) : _vm._e()])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "button",
    class: [_vm.pagination.current_page === _vm.pagination.last_page ? 'is-disabled' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.nextPrev($event, _vm.pagination.current_page + 1)
      }
    }
  }, [_c('span', [_vm._v("»")])])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40117922","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/hyper-table/HyperTablePagination.vue
// module id = 1117
// module chunks = 39